import { types as t } from 'mobx-state-tree'
import { ScatterplotModel } from './ScatterplotState'

export const StateModel = t
  .model('StateModel', {
    ScatterplotState: ScatterplotModel,
  })
  .views((self) => ({}))
  .actions((self) => ({
    resetSubState(subState: any) {
      const subStateName = subState.$treenode.subpath
      self[subStateName] = {}
    },
  }))

export type StateType = typeof StateModel.Type
export interface IStateable {
  state?: StateType
}
